import React from 'react';
import styles from './index.module.scss';

const Report = () => {
    return (
        <svg xmlns='http://www.w3.org/2000/svg' width='26' height='26' viewBox='0 0 26 26'>
            <defs>
                <linearGradient id='a' x1='0.5' x2='0.5' y2='1' gradientUnits='objectBoundingBox'>
                    <stop offset='0' stopColor='#ea2c2f' />
                    <stop offset='1' stopColor='#8e0003' />
                </linearGradient>
            </defs>
            <path
                d='M25.071,6.5H20.429V.929A.929.929,0,0,0,19.5,0H.929A.929.929,0,0,0,0,.929V22.286A3.714,3.714,0,0,0,3.714,26H22.286A3.714,3.714,0,0,0,26,22.286V7.429A.929.929,0,0,0,25.071,6.5Z'
                fill='url(#a)'
            />
            <path
                d='M120.395,85.333h5.571a.929.929,0,0,1,0,1.857h-5.571a.929.929,0,1,1,0-1.857Z'
                transform='translate(-112.966 -80.69)'
                fill='#ff797b'
            />
            <path
                d='M80.337,377.323H69.195a.929.929,0,0,1,0-1.857H80.337a.929.929,0,0,1,0,1.857Z'
                transform='translate(-64.552 -355.037)'
                fill='#ff797b'
            />
            <path
                d='M80.337,309.056H69.195a.929.929,0,1,1,0-1.857H80.337a.929.929,0,1,1,0,1.857Z'
                transform='translate(-64.552 -290.485)'
                fill='#ff797b'
            />
            <path
                d='M80.337,240.79H69.195a.929.929,0,1,1,0-1.857H80.337a.929.929,0,0,1,0,1.857Z'
                transform='translate(-64.552 -225.933)'
                fill='#ff797b'
            />
            <path
                d='M80.337,172.523H69.195a.929.929,0,0,1,0-1.857H80.337a.929.929,0,0,1,0,1.857Z'
                transform='translate(-64.552 -161.38)'
                fill='#ff797b'
            />
            <path
                d='M379.181,167.529a1.857,1.857,0,1,1-3.714,0V153.6h3.714v13.929Z'
                transform='translate(-355.038 -145.243)'
                fill='#ff797b'
            />
        </svg>
    );
};

export default Report;
